import Swiper from "swiper/dist/js/swiper.js";

export default {
  init() {
    const homeBanner = new Swiper('#home-swiper', {
      direction: 'horizontal',
      loop: true,
      speed: 800,
      a11y: true,
      noSwiping: true,
      noSwipingClass: 'swiper-no-swiping',
      autoplay: {
        delay: 5000,
       },
    });

    const bannerPause = document.querySelector('#banner-pause')
    bannerPause.addEventListener('click', function(e) {
      e.preventDefault()
      if (homeBanner.autoplay.running) {
        homeBanner.autoplay.stop();
        bannerPause.classList.add('paused')
      } else {
        homeBanner.autoplay.start();
        bannerPause.classList.remove('paused')
      }
    });

    const testimonialBanner = new Swiper('#testimonial-swiper', {
      direction: 'horizontal',
      speed: 800,
      a11y: true,
      navigation: {
        nextEl: '#testimonial-swiper .swiper-button-next',
        prevEl: '#testimonial-swiper .swiper-button-prev'
      }
    });
	},
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};
